/**
 * Extracted styles for App.tsx to prevent unnecessary re-renders
 * All inline styles are defined as constants outside the component
 */

import { CSSProperties } from 'react';
import { UI_CONSTANTS } from './constants';

// Loading screen styles
export const loadingContainerStyle: CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(to bottom right, #0a1929, #102a43)'
};

export const loadingTextStyle: CSSProperties = {
  color: 'white',
  fontSize: '20px'
};

// Error page styles
export const errorContainerStyle: CSSProperties = {
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  background: 'linear-gradient(to bottom right, #0a1929, #102a43)',
  color: 'white',
  padding: '2rem'
};

export const errorContainerWithTextAlignStyle: CSSProperties = {
  ...errorContainerStyle,
  textAlign: 'center'
};

export const errorHeadingStyle: CSSProperties = {
  fontSize: '2rem',
  marginBottom: '1rem'
};

export const errorMessageStyle: CSSProperties = {
  marginBottom: '2rem'
};

export const errorButtonStyle: CSSProperties = {
  padding: '0.75rem 2rem',
  fontSize: '1rem',
  background: '#3b82f6',
  color: 'white',
  border: 'none',
  borderRadius: '0.5rem',
  cursor: 'pointer'
};

// Theme toggle container style
export const themeToggleContainerStyle: CSSProperties = {
  position: 'fixed',
  bottom: '2rem',
  right: '2rem',
  zIndex: UI_CONSTANTS.Z_INDEX.tooltip
};

// CSS classes for better performance (can be added to App.css)
export const appStyles = `
  .app-loading-container {
    min-height: 100vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom right, #0a1929, #102a43);
  }

  .app-loading-text {
    color: white;
    font-size: 20px;
  }

  .app-error-container {
    min-height: 100vh;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    background: linear-gradient(to bottom right, #0a1929, #102a43);
    color: white;
    padding: 2rem;
  }

  .app-error-container--centered {
    text-align: center;
  }

  .app-error-heading {
    font-size: 2rem;
    margin-bottom: 1rem;
  }

  .app-error-message {
    margin-bottom: 2rem;
  }

  .app-error-button {
    padding: 0.75rem 2rem;
    font-size: 1rem;
    background: #3b82f6;
    color: white;
    border: none;
    border-radius: 0.5rem;
    cursor: pointer;
    transition: background-color 0.2s ease;
  }

  .app-error-button:hover {
    background: #2563eb;
  }

  .app-error-button:active {
    background: #1d4ed8;
  }

  .app-theme-toggle-container {
    position: fixed;
    bottom: 2rem;
    right: 2rem;
    z-index: 50;
  }
`;